
import Helper from '../../lib/helper';
import React, { Component } from 'react';
import RichTextEditor from 'react-rte';

import { ActionCreators } from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
        {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
        {label: 'Italic', style: 'ITALIC'},
        {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_BUTTONS: [
        {label: 'UL', style: 'unordered-list-item'},
        {label: 'OL', style: 'ordered-list-item'}
    ]
};

class JobForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slug: "",
            job: {
                id: "",
                jobTitle: "",
                shortDesc: "",
                jobTypeId: "",
                jobLocationIds: [],
                salaryStart: 0,
                salaryEnd: 0,
                jobFunctionId: {},
                requirement: ""
            },
            RTE:{
                requirement: RichTextEditor.createEmptyValue()
            },
            thumbnailFile:{},
            errors: []
        }
    }

    componentWillMount(){
        this.props.jobFunction();
        this.props.jobLocation();
        this.props.jobType();

        let slug = this.props.match.params.slug;

        if(slug){
            this.setState(prevState => ({
                ...prevState,
                slug: slug
            }))
            this.props.vacancyBySlugAction(slug).then(() => {
                if(this.props.vacancyBySlug){
                    let _v = this.props.vacancyBySlug;
                    this.setState(prevState => ({
                        ...prevState,
                        job: {
                            ...prevState.job,
                            id: _v.id,
                            jobTitle: _v.jobTitle,
                            shortDesc: _v.shortDesc,
                            jobTypeId: _v.jobTypeId,
                            jobLocationIds: _v.jobLocationIds,
                            salaryStart: _v.salaryStart,
                            salaryEnd: _v.salaryEnd,
                            jobFunctionId: _v.jobFunctionId,
                            requirement: _v.requirement
                        },
                        RTE:{
                            requirement : RichTextEditor.createValueFromString(_v.requirement, 'html')
                        }
                    }))
                }
            });
        }
        else{
            this.setState(prevState => ({
                ...prevState,
                job: {
                    ...prevState.job,
                    jobTypeId: this.props.jobTypes ? this.props.jobTypes[0].id : "",
                    jobFunctionId: this.props.jobFunctions ? this.props.jobFunctions[0].id : ''
                }
            }))
        }
    }

    submit(){
        let error = [];

        Object.keys(this.state.job).forEach((k,i) => {
            if((k !== "id" && k !== "salaryStart" && k !== "salaryEnd") && (!this.state.job[k] || this.state.job[k] === "")) error.push({field: k, error: "required"});
        })

        if(this.state.job.jobLocationIds.length === 0){
            error.push({field: "jobLocation", error: "required"});
        }
        // if(!this.state.thumbnailFile.size && this.state.job.id === ""){
        //     error.push({field: "thumbnailFile", error: "required"});
        // }
        if(this.state.thumbnailFile && this.state.thumbnailFile.size >= 2097152){
            error.push({field: "thumbnailFile", error: "Please choose smaller file"});
        }

        this.setState(prevState => ({
            ...prevState,
            errors: error
        }));

        console.log(error);

        if(error.length === 0){
            let job = this.state.job;
            if(job.id === "") delete job.id;
            let data = new FormData();
                data.append("ThumbnailFile", this.state.thumbnailFile);
                data.append("DataVacancy", JSON.stringify(job) );

            if(this.props.match.params.slug){
                this.props.vacancyPutAction(data, job.id).then(() => {
                    if(this.props.vacancyPostState){
                        this.props.push("/aoc/jobs")
                    }
                })
            }
            else{
                this.props.vacancyPostAction(data).then(() => {
                    if(this.props.vacancyPostState){
                        this.props.push("/aoc/jobs")
                    }
                })
            }
        }
    }

    render() {
        return (
            <div className="row justify-content-center">
                <div className="col-xl-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Job Title*</label>
                                        <input
                                            value={ this.state.job.jobTitle }
                                            onChange={ (event) => {
                                                this.setState({
                                                    ...this.state,
                                                    job: {
                                                        ...this.state.job,
                                                        jobTitle: event.target.value
                                                    }
                                                })
                                            }}
                                            type="text" />
                                        {
                                            this.state.errors.map(x => x.field).indexOf("jobTitle") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "jobTitle").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Short description*</label>
                                        <textarea
                                            value={ this.state.job.shortDesc }
                                            onChange={ (event) => {
                                                this.setState({
                                                    ...this.state,
                                                    job: {
                                                        ...this.state.job,
                                                        shortDesc: event.target.value
                                                    }
                                                })
                                            }}></textarea>
                                        {
                                            this.state.errors.map(x => x.field).indexOf("shortDesc") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "shortDesc").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Job Type*</label>
                                        <div className="select">
                                            <select
                                                value={ this.state.job.jobTypeId }
                                                onChange={ (event) => {
                                                    this.setState({
                                                        ...this.state,
                                                        job: {
                                                            ...this.state.job,
                                                            jobTypeId: event.target.value
                                                        }
                                                    })
                                                }}>
                                                {
                                                    this.props.jobTypes &&
                                                    this.props.jobTypes.map((t,i) => {
                                                        return <option key={i} value={t.id}>{ t.type }</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                        {
                                            this.state.errors.map(x => x.field).indexOf("jobType") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "jobType").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Job Locations*</label>
                                        { this.props.jobLocations &&
                                            this.props.jobLocations.map((l,i) => {
                                                return <label key={i}>
                                                            <input
                                                                type="checkbox"
                                                                value={ this.state.job.jobLocationIds.indexOf(l.id) > -1 }
                                                                checked={ this.state.job.jobLocationIds.indexOf(l.id) > -1 }
                                                                onChange={ (event) => {
                                                                    let locationsIds = this.state.job.jobLocationIds;
                                                                    if( this.state.job.jobLocationIds.indexOf(l.id) < 0 ){
                                                                        locationsIds.push(l.id);
                                                                    }
                                                                    else{
                                                                        locationsIds.splice(locationsIds.indexOf(l.id), 1);
                                                                    }
                                                                    this.setState({
                                                                        ...this.state,
                                                                        job: {
                                                                            ...this.state.job,
                                                                            jobLocationIds: locationsIds
                                                                        }
                                                                    })
                                                                }}
                                                                />
                                                            { l.location }
                                                        </label>
                                            })
                                        }
                                        {
                                            this.state.errors.map(x => x.field).indexOf("jobLocation") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "jobLocation").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Salary Range</label>
                                        <div className="row">
                                            <div className="col-6">
                                                <input
                                                    type="text"
                                                    value={ Helper.numberFormatter(this.state.job.salaryStart) }
                                                    onChange={ (event) => {
                                                        this.setState({
                                                            ...this.state,
                                                            job: {
                                                                ...this.state.job,
                                                                salaryStart: Helper.numberUnformatter(event.target.value)
                                                            }
                                                        })
                                                    }}
                                                />
                                                {
                                                    this.state.errors.map(x => x.field).indexOf("salaryStart") > -1 &&
                                                    <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "salaryStart").error }</span>
                                                }
                                            </div>
                                            <div className="col-6">
                                                <input
                                                    type="text"
                                                    value={ Helper.numberFormatter(this.state.job.salaryEnd) }
                                                    onChange={ (event) => {
                                                        this.setState({
                                                            ...this.state,
                                                            job: {
                                                                ...this.state.job,
                                                                salaryEnd: Helper.numberUnformatter(event.target.value)
                                                            }
                                                        })
                                                    }}
                                                />
                                                {
                                                    this.state.errors.map(x => x.field).indexOf("salaryEnd") > -1 &&
                                                    <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "salaryEnd").error }</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Job Function*</label>
                                        <div className="select">
                                            <select
                                                value={ this.state.job.jobFunctionId }
                                                onChange={ (event) => {
                                                    this.setState({
                                                        ...this.state,
                                                        job: {
                                                            ...this.state.job,
                                                            jobFunctionId: event.target.value
                                                        }
                                                    })
                                                }}>
                                                {
                                                    this.props.jobFunctions &&
                                                    this.props.jobFunctions.map((t,i) => {
                                                        return <option key={i} value={t.id}>{ t.function }</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                        {
                                            this.state.errors.map(x => x.field).indexOf("jobFunction") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "jobFunction").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Requirement*</label>
                                        <RichTextEditor
                                            value={this.state.RTE.requirement}
                                            onChange={ (value) => {
                                                this.setState({
                                                    ...this.state,
                                                    job: {
                                                        ...this.state.job,
                                                        requirement: value.toString('html')
                                                    },
                                                    RTE:{
                                                        ...this.state.RTE,
                                                        requirement: value
                                                    }
                                                })
                                            }}
                                            toolbarConfig={toolbarConfig}
                                        />
                                        {
                                            this.state.errors.map(x => x.field).indexOf("requirement") > -1 &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "requirement").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-field">
                                        <label>Thumbnail Picture</label>
                                        <input
                                            onChange={ (event) => {
                                                this.setState({
                                                    ...this.state,
                                                    thumbnailFile: event.target.files[0]
                                                })
                                            }}
                                            type="file"
                                            accept="image/png,image/jpeg"/>
                                        <small>Max size 2Mb. Allowed extentions: .jpg, .jpeg, .png</small><br/>
                                        {
                                            this.state.errors.find(x => x.field === "thumbnailFile") &&
                                            <span className="fieldErrorText">{ this.state.errors.find(x => x.field === "thumbnailFile").error }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <button onClick={() => {this.submit()}} type="button" className="gs-btn gs-btn-blue btn-lg">Save Job</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        jobFunctions: state.jobFunctions,
        jobLocations: state.jobLocations,
        jobTypes: state.jobTypes,
        vacancyBySlug : state.vacancyBySlug,
        vacancyPostState: state.vacancyPost
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobForm));


// WEBPACK FOOTER //
// ./src/pages/auth/jobForm.js